export function initFooter() {
    const socialIconsBanner = $('.custom-footer__banner5')

    socialIconsBanner.hide()
    socialIconsBanner.find('.footer-links-icons').insertBefore('.footer-bottom')
}
